import { render, staticRenderFns } from "./StyleStepName.vue?vue&type=template&id=22fc413a&scoped=true"
import script from "./StyleStepName.vue?vue&type=script&lang=js"
export * from "./StyleStepName.vue?vue&type=script&lang=js"
import style0 from "./StyleStepName.vue?vue&type=style&index=0&id=22fc413a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fc413a",
  null
  
)

export default component.exports